import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/consulta')({
  component: ConsultaLayout,
});

function ConsultaLayout() {
  return <Outlet />;
}
